// extracted by mini-css-extract-plugin
export default {"backButton":"backButton_backButton__eDJ4b","backButtonCompact":"backButton_backButtonCompact__hHdvu"};